import { LoggerService } from '../../../core/services/logger.service';
import { MessageImage } from '../../../core/models/message-image.model';
import {
  Component,
  OnInit,
  Input,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { ASCII_REMOTE_KEYS } from '../../../core/services/remote-control.service';

@Component({
    selector: 'cm-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.scss'],
    standalone: false
})
export class ImageViewerComponent implements OnInit {
  @Input() images: MessageImage[];
  @Input() currentImage: MessageImage;

  @Output() backPressed = new EventEmitter<MessageImage>();

  currentImageIndex: number;
  imageUrlA = '';
  imageUrlB = '';
  activeSlot: 'a' | 'b' = 'a';
  private isTransitioning = false;

  private static readonly CROSSFADE_DURATION = 400;

  constructor(private logger: LoggerService) {}

  ngOnInit(): void {
    if (!this.currentImage) {
      this.currentImage = this.images[0];
    }

    this.currentImageIndex = this.images.findIndex(
      (image) => image.id === this.currentImage.id
    );

    this.imageUrlA = this.currentImage.original_url;
    this.activeSlot = 'a';
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown($event: KeyboardEvent): boolean {
    switch ($event.keyCode) {
      case ASCII_REMOTE_KEYS.left:
        this.previous();
        break;
      case ASCII_REMOTE_KEYS.right:
        this.next();
        break;
      case ASCII_REMOTE_KEYS.back:
        this.backPressed.emit(this.currentImage);
        break;
      case ASCII_REMOTE_KEYS.blue:
        this.backPressed.emit(this.currentImage);
        break;
      case ASCII_REMOTE_KEYS.ok:
        break;
    }

    return false;
  }

  next(): void {
    if (this.isTransitioning) return;
    if (this.currentImageIndex < this.images.length - 1) {
      this.currentImageIndex += 1;
      this.currentImage = this.images[this.currentImageIndex];
      this.crossfadeTo(this.currentImage.original_url);
    }
  }

  previous(): void {
    if (this.isTransitioning) return;
    if (this.currentImageIndex > 0) {
      this.currentImageIndex -= 1;
      this.currentImage = this.images[this.currentImageIndex];
      this.crossfadeTo(this.currentImage.original_url);
    }
  }

  private crossfadeTo(url: string): void {
    this.isTransitioning = true;

    if (this.activeSlot === 'a') {
      this.imageUrlB = url;
      this.activeSlot = 'b';
    } else {
      this.imageUrlA = url;
      this.activeSlot = 'a';
    }

    setTimeout(() => {
      this.isTransitioning = false;
    }, ImageViewerComponent.CROSSFADE_DURATION);
  }
}
